/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Fact_3_VInputs */

const en_cp_fact_3_v = /** @type {(inputs: Cp_Fact_3_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecturers free`)
};

const id_cp_fact_3_v = /** @type {(inputs: Cp_Fact_3_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dosen gratis`)
};

/**
* | output |
* | --- |
* | "Lecturers free" |
*
* @param {Cp_Fact_3_VInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_fact_3_v = /** @type {((inputs?: Cp_Fact_3_VInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Fact_3_VInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_fact_3_v(inputs)
	return en_cp_fact_3_v(inputs)
});